import { acpBillpayStates } from './states';

export default (appModule) => {
  appModule.config(acpBillpayStates);
};
